import { SVGProps } from 'react';

export const CategoryTravelPrivate = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} width='186' height='225' viewBox='0 0 186 225' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M111.082 101.39C139.08 101.39 161.777 78.6934 161.777 50.6952C161.777 22.697 139.08 0 111.082 0C83.0839 0 60.3868 22.697 60.3868 50.6952C60.3868 78.6934 83.0839 101.39 111.082 101.39Z'
      fill='#C1B499'
    />
    <path
      d='M38.0247 147.312C18.5116 147.312 2.69287 162.987 2.69287 182.318C2.69287 201.649 18.5116 217.325 38.0247 217.325C57.5379 217.325 73.3566 201.649 73.3566 182.318C73.3566 162.987 57.5379 147.312 38.0247 147.312ZM38.0247 214.398C20.1507 214.398 5.64586 200.036 5.64586 182.318C5.64586 164.6 20.1377 150.239 38.0247 150.239C55.8988 150.239 70.4036 164.6 70.4036 182.318C70.4036 200.036 55.8988 214.398 38.0247 214.398Z'
      fill='#C1B499'
    />
    <path
      d='M38.0247 144.645C17.0285 144.645 0 161.504 0 182.318C0 203.132 17.0285 219.992 38.0247 219.992C59.0209 219.992 76.0494 203.132 76.0494 182.318C76.0494 161.504 59.0209 144.645 38.0247 144.645ZM38.0247 216.831C18.7847 216.831 3.18715 201.376 3.18715 182.318C3.18715 163.26 18.7847 147.806 38.0247 147.806C57.2647 147.806 72.8622 163.26 72.8622 182.318C72.8622 201.376 57.2647 216.831 38.0247 216.831Z'
      fill='#434748'
    />
    <path
      d='M38.0248 185.297C40.2232 185.297 42.0054 183.515 42.0054 181.316C42.0054 179.118 40.2232 177.336 38.0248 177.336C35.8263 177.336 34.0441 179.118 34.0441 181.316C34.0441 183.515 35.8263 185.297 38.0248 185.297Z'
      fill='#FF5E00'
    />
    <path
      d='M38.0247 183.047C37.6994 183.047 37.3612 182.956 37.062 182.76C36.2685 182.227 36.0473 181.147 36.5807 180.354L43.5404 169.947C43.5794 169.895 46.5064 165.524 47.8853 159.761L55.8987 124.403C56.1069 123.466 57.0435 122.881 57.9671 123.102C58.9038 123.31 59.4892 124.247 59.268 125.171L51.2546 160.541C51.2546 160.554 51.2546 160.554 51.2546 160.567C49.7196 166.968 46.5454 171.69 46.4153 171.898L39.4556 182.305C39.1304 182.773 38.584 183.047 38.0247 183.047Z'
      fill='#9D9B95'
    />
    <path
      d='M114.477 137.49H55.4954C54.5328 137.49 53.7653 136.709 53.7653 135.76C53.7653 134.797 54.5458 134.03 55.4954 134.03H114.477C115.44 134.03 116.207 134.81 116.207 135.76C116.207 136.709 115.44 137.49 114.477 137.49Z'
      fill='#9D9B95'
    />
    <path
      d='M101.013 197.278C106.596 197.278 111.121 192.753 111.121 187.171C111.121 181.588 106.596 177.063 101.013 177.063C95.4308 177.063 90.9054 181.588 90.9054 187.171C90.9054 192.753 95.4308 197.278 101.013 197.278Z'
      fill='#8B7E62'
    />
    <path d='M56.7726 134.651L54.1815 136.944L99.6896 188.357L102.281 186.064L56.7726 134.651Z' fill='#9D9B95' />
    <path
      d='M147.702 147.312C128.189 147.312 112.37 162.987 112.37 182.318C112.37 201.649 128.189 217.325 147.702 217.325C167.215 217.325 183.034 201.649 183.034 182.318C183.034 162.987 167.215 147.312 147.702 147.312ZM147.702 214.398C129.828 214.398 115.323 200.036 115.323 182.318C115.323 164.6 129.815 150.239 147.702 150.239C165.576 150.239 180.081 164.6 180.081 182.318C180.081 200.036 165.576 214.398 147.702 214.398Z'
      fill='#C1B499'
    />
    <path
      d='M147.702 144.645C126.706 144.645 109.677 161.504 109.677 182.318C109.677 203.132 126.706 219.992 147.702 219.992C168.698 219.992 185.726 203.132 185.726 182.318C185.726 161.504 168.698 144.645 147.702 144.645ZM147.702 216.831C128.462 216.831 112.864 201.376 112.864 182.318C112.864 163.26 128.462 147.806 147.702 147.806C166.942 147.806 182.539 163.26 182.539 182.318C182.539 201.376 166.942 216.831 147.702 216.831Z'
      fill='#434748'
    />
    <path
      d='M59.1119 126.341C59.0468 126.341 58.9688 126.341 58.9037 126.328L51.4887 125.431C50.5391 125.314 49.8626 124.455 49.9797 123.505C50.0968 122.556 50.9554 121.879 51.905 121.996L59.32 122.894C60.2697 123.011 60.9461 123.87 60.8291 124.819C60.725 125.704 59.9705 126.341 59.1119 126.341Z'
      fill='#9D9B95'
    />
    <path d='M117.772 120.45L111.665 143.191L113.851 143.778L119.958 121.037L117.772 120.45Z' fill='#434748' />
    <path
      d='M101.013 188.901C100.87 188.901 100.714 188.888 100.558 188.836C99.6343 188.589 99.0879 187.639 99.3351 186.715L113.853 132.677C114.1 131.753 115.05 131.207 115.973 131.454C116.897 131.701 117.443 132.651 117.196 133.574L102.678 187.613C102.47 188.393 101.768 188.901 101.013 188.901Z'
      fill='#9D9B95'
    />
    <path
      d='M147.702 185.844C150.202 185.844 152.229 183.817 152.229 181.317C152.229 178.816 150.202 176.79 147.702 176.79C145.202 176.79 143.175 178.816 143.175 181.317C143.175 183.817 145.202 185.844 147.702 185.844Z'
      fill='#FF5E00'
    />
    <path
      d='M108.831 115.427H132.403L133.041 117.573L126.966 121.489C126.966 121.489 120.695 125.73 115.349 120.774C115.349 120.774 114.074 119.473 112.045 119.473H108.818V115.427H108.831Z'
      fill='#9D9B95'
    />
    <path
      d='M132.417 117.743C133.078 117.743 133.613 117.224 133.613 116.585C133.613 115.945 133.078 115.427 132.417 115.427C131.756 115.427 131.22 115.945 131.22 116.585C131.22 117.224 131.756 117.743 132.417 117.743Z'
      fill='#9D9B95'
    />
    <path
      d='M108.832 119.46C109.988 119.46 110.926 118.557 110.926 117.443C110.926 116.33 109.988 115.427 108.832 115.427C107.675 115.427 106.737 116.33 106.737 117.443C106.737 118.557 107.675 119.46 108.832 119.46Z'
      fill='#9D9B95'
    />
    <path
      d='M148.157 182.24C147.793 182.24 147.429 182.071 147.194 181.746L113.853 136.462C113.463 135.929 113.58 135.174 114.113 134.784C114.646 134.394 115.401 134.511 115.791 135.044L149.133 180.328C149.523 180.861 149.406 181.616 148.873 182.006C148.651 182.162 148.404 182.24 148.157 182.24Z'
      fill='#9D9B95'
    />
    <path
      d='M101 188.901C100.142 188.901 99.3871 188.263 99.2831 187.379C99.166 186.429 99.8424 185.557 100.792 185.44L147.481 179.586C148.43 179.469 149.302 180.146 149.419 181.095C149.536 182.045 148.86 182.917 147.91 183.034L101.221 188.888C101.143 188.901 101.078 188.901 101 188.901Z'
      fill='#9D9B95'
    />
    <path
      d='M51.5148 125.431C46.6626 124.911 45.5048 121.841 45.5698 120.24V116.26H49.0301V120.332C49.0432 120.527 49.2383 121.697 51.8921 121.984L51.5148 125.431Z'
      fill='#434748'
    />
    <path
      d='M84.8304 181.095L101.508 185.505C102.431 185.753 102.991 186.702 102.743 187.626C102.496 188.549 101.547 189.109 100.623 188.862C100.519 188.836 84.271 183.372 84.1539 183.333C82.7489 182.813 83.3473 180.757 84.8304 181.095Z'
      fill='#9D9B95'
    />
    <path
      d='M89.8518 180.068C90.047 180.627 89.7478 181.252 89.1884 181.447L79.8481 184.738C79.2887 184.933 78.6643 184.634 78.4691 184.075C78.274 183.515 78.5732 182.891 79.1326 182.696L88.4729 179.404C89.0323 179.209 89.6437 179.508 89.8518 180.068Z'
      fill='#70706F'
    />
    <path
      d='M52.1131 108.936L43.8396 109.482C43.8396 109.482 41.9012 109.43 41.9012 111.837V115.843C41.9143 116.195 42.0443 116.949 42.7208 117.339L46.5454 120.162L45.4136 115.388C45.4136 115.388 45.2835 112.175 47.9373 114.217L49.9927 118.094L52.9327 115.089C52.9327 115.089 54.6759 113.45 54.4937 111.876L52.1131 108.936Z'
      fill='white'
    />
    <path
      d='M47.846 119.83C47.891 119.503 47.5581 119.186 47.1026 119.124C46.647 119.061 46.2413 119.276 46.1963 119.603C46.1513 119.931 46.4841 120.247 46.9397 120.31C47.3952 120.372 47.801 120.157 47.846 119.83Z'
      fill='white'
    />
    <path d='M44.8022 114.1C44.8022 114.1 46.0121 110.965 48.6529 113.411L44.8022 114.1Z' fill='#E6E1DD' />
    <path
      d='M47.287 119.564C49.1046 119.564 50.5782 118.09 50.5782 116.273C50.5782 114.455 49.1046 112.981 47.287 112.981C45.4693 112.981 43.9957 114.455 43.9957 116.273C43.9957 118.09 45.4693 119.564 47.287 119.564Z'
      fill='#C1B499'
    />
    <path
      d='M47.2869 118.926C48.7525 118.926 49.9406 117.738 49.9406 116.272C49.9406 114.807 48.7525 113.619 47.2869 113.619C45.8212 113.619 44.6331 114.807 44.6331 116.272C44.6331 117.738 45.8212 118.926 47.2869 118.926Z'
      fill='#9D9B95'
    />
    <path
      d='M85.4548 207.802L85.8191 216.297L90.3071 218.808L96.1351 214.944V209.637L85.4548 207.802Z'
      fill='#E6E1DD'
    />
    <path
      d='M96.6684 131.389L80.2643 136.436L80.8887 103.017L80.5635 89.0322C80.5635 89.0322 79.874 67.5286 84.8954 64.3545L96.6684 131.389Z'
      fill='#70706F'
    />
    <path d='M62.4813 104.292L51.1766 109.248L53.232 113.463L64.5757 109.807L62.4813 104.292Z' fill='white' />
    <path
      d='M59.5942 115.857C60.3008 115.573 60.044 113.278 59.0206 110.732C57.9972 108.185 56.5947 106.351 55.888 106.635C55.1814 106.919 55.4382 109.213 56.4616 111.76C57.485 114.307 58.8875 116.141 59.5942 115.857Z'
      fill='#70706F'
    />
    <path d='M83.0741 94.1445L55.8597 106.62L59.5412 115.843L82.879 108.558L83.0741 94.1445Z' fill='#70706F' />
    <path d='M78.9894 98.0733L81.7733 71.1321L84.5181 93.143L78.9894 98.0733Z' fill='#70706F' />
    <path
      d='M87.9655 66.8262L86.8337 57.6421L82.3067 62.2211C82.0205 62.5594 81.1749 63.6782 81.6172 65.6295L84.6092 77.2983L87.9655 66.8262Z'
      fill='#434748'
    />
    <path d='M97.3187 50.0579L95.6536 50.0969L96.6292 51.8401L97.3187 50.0579Z' fill='#434748' />
    <path
      d='M94.2095 45.4788L97.5788 53.323L86.8856 62.9495L84.0367 57.746C84.0367 57.746 82.3585 55.1572 82.9309 52.5165L94.2095 45.4788Z'
      fill='#E6E1DD'
    />
    <path d='M115.011 112.604L124.728 106.659L113.033 101.169L115.011 112.604Z' fill='#9D9B95' />
    <path
      d='M126.315 88.5769C126.315 88.5769 128.982 87.315 127.72 83.7376L121.944 67.2945C121.944 67.2945 119.889 60.9462 118.861 67.2685L116.39 92.7657L126.315 88.5769Z'
      fill='#70706F'
    />
    <path
      d='M118.497 70.1174L125.509 100.636C125.509 100.636 127.447 107.023 123.115 107.114L118.198 107.218C118.198 107.218 114.1 107.583 114.789 101.781L118.497 70.1174Z'
      fill='white'
    />
    <path
      d='M118.861 67.2686C119.16 65.3953 119.564 64.6407 119.967 64.4976V64.4846L112.032 65.8766L114.842 102.639L118.861 67.2686Z'
      fill='#434748'
    />
    <path
      d='M117.118 131.272C117.118 131.272 115.596 142.043 108.025 150.252L102.965 156.535L99.192 210.716L85.0775 209.663C85.0775 209.663 84.3099 180.276 84.0498 170.61C83.8156 161.543 83.5294 133.626 83.5294 133.626L117.118 131.272Z'
      fill='#434748'
    />
    <path
      d='M130.842 200.829L136.137 206.514L146.349 204.836L145.373 200.869L138.7 193.753L130.842 200.829Z'
      fill='white'
    />
    <path d='M136.137 206.515L138.817 206.072L140.976 196.186L131.792 201.844L136.137 206.515Z' fill='#E6E1DD' />
    <path
      d='M112.357 136.918L116.182 155.403C116.182 155.403 117.938 163.404 122.231 169.518C122.231 169.518 129.815 180.445 140.898 195.405L129.958 204.329C129.958 204.329 101.065 171.131 98.9449 169.167L100.389 151.631L112.357 136.918Z'
      fill='#434748'
    />
    <path
      d='M85.3507 62.9756C85.3507 62.9756 84.31 63.9512 84.2449 66.8652C84.1799 69.441 82.2416 137.607 82.2416 137.607L120.409 129.958L115.999 100.402L114.074 74.3322L108.91 59.3591L99.127 53.6743L85.3507 62.9756Z'
      fill='#70706F'
    />
    <path
      d='M101.937 127.733C90.3851 129.307 80.3163 133.132 80.2643 136.514C80.2252 139.714 90.6062 140.469 102.158 138.362C112.669 136.449 120.487 132.82 120.422 130.114C120.37 127.408 112.461 126.289 101.937 127.733Z'
      fill='#70706F'
    />
    <path
      d='M96.1739 125.105L93.2469 135.695L93.377 139.025L103.277 137.477C103.277 137.477 104.044 133.743 103.355 130.127C102.665 126.51 103.069 123.388 103.212 122.178L96.1739 125.105Z'
      fill='white'
    />
    <path
      d='M93.6243 134.368C93.6243 134.368 93.26 135.591 93.3251 137.243L92.6356 135.213L93.6243 134.368Z'
      fill='#70706F'
    />
    <path
      d='M95.2893 73.2004C95.1072 64.4976 99.1529 57.3558 104.33 57.2517C109.235 57.1477 113.398 63.4049 113.97 71.4703C113.97 71.4053 113.97 71.3532 113.97 71.2882C113.788 62.7414 108.831 55.9118 102.886 56.0419C96.9414 56.172 92.2713 63.1967 92.4534 71.7435C92.5965 78.2479 95.4974 83.7506 99.5041 85.9621C97.0585 83.1522 95.3934 78.495 95.2893 73.2004Z'
      fill='#FF5E00'
    />
    <path
      d='M114.113 72.3811C114.282 80.4595 110.236 87.094 105.059 87.198C99.8945 87.3021 95.5625 80.8498 95.3934 72.7713C95.2243 64.6929 99.27 57.8893 104.448 57.9543C110.575 58.0194 113.944 64.3026 114.113 72.3811Z'
      fill='#70706F'
    />
    <path
      d='M93.8973 125.6L97.3187 97.8781L95.4064 72.7711L114.113 72.3809L114.503 91.1005C114.503 91.1005 114.646 99.9985 112.89 107.335L109.339 122.907C109.352 122.907 99.7643 126.159 93.8973 125.6Z'
      fill='#70706F'
    />
    <path
      d='M68.114 224.089C69.7449 224.089 71.067 223.157 71.067 222.008C71.067 220.858 69.7449 219.927 68.114 219.927C66.4831 219.927 65.161 220.858 65.161 222.008C65.161 223.157 66.4831 224.089 68.114 224.089Z'
      fill='#9D9B95'
    />
    <path
      d='M95.3675 225H69.493C69.493 225 66.4229 224.935 65.2651 222.593L67.2685 220.018L71.3793 219.51C71.3793 219.51 73.916 219.133 75.8283 217.663L83.3474 211.848L83.4124 211.796C83.4124 211.796 83.4514 211.757 83.5165 211.705C83.5295 211.692 83.5425 211.679 83.5555 211.666C83.7766 211.51 84.0368 211.432 84.323 211.432C84.8824 211.432 85.3637 211.77 85.5849 212.251C85.5979 212.291 85.6109 212.316 85.6239 212.342C85.6239 212.342 85.6239 212.343 85.6239 212.356C86.4304 214.281 88.4078 215.959 90.7103 216.466C93.4422 217.065 95.6927 215.842 96.122 213.669C96.122 213.656 96.122 213.656 96.122 213.656C96.148 213.526 96.2 213.409 96.2781 213.305C96.4472 213.058 96.7464 212.889 97.0716 212.889C97.5529 212.889 97.9562 213.24 98.0343 213.708C98.0343 213.734 98.0473 213.747 98.0473 213.773L99.14 222.32C99.14 222.307 99.5953 225 95.3675 225Z'
      fill='#9D9B95'
    />
    <path
      d='M150.668 201.636L146.011 198.28L144.554 199.464C144.814 199.984 144.97 200.53 144.97 201.103C144.97 203.691 141.978 205.604 138.296 205.383C136.501 205.279 134.875 204.68 133.678 203.796C133.652 203.783 133.626 203.783 133.6 203.77L131.389 214.658C131.389 214.658 130.946 217.299 128.709 218.639L126.185 220.017L125.665 220.343C124.767 221.006 124.195 221.618 124.312 222.502C124.338 222.749 124.416 222.983 124.546 223.205C124.702 223.478 124.923 223.712 125.196 223.881C125.808 224.271 126.653 224.362 127.499 224.128L127.863 223.998C127.863 223.998 127.876 223.998 127.876 223.985L135.643 221.917C135.643 221.917 140.196 220.265 143.318 217.143L152.06 208.479C152.021 208.492 155.455 205.044 150.668 201.636Z'
      fill='#9D9B95'
    />
    <path
      d='M145.412 200.036C145.951 200.036 146.388 199.599 146.388 199.061C146.388 198.522 145.951 198.085 145.412 198.085C144.873 198.085 144.437 198.522 144.437 199.061C144.437 199.599 144.873 200.036 145.412 200.036Z'
      fill='#9D9B95'
    />
    <path
      d='M93.364 138.31L93.5461 142.785C93.5461 142.785 93.5982 143.942 94.3397 144.528L96.7073 145.803C96.7073 145.803 97.8 146.414 98.4765 145.868C98.6846 145.699 98.7627 145.282 98.3464 144.762L96.265 142.459L95.9918 137.997L93.364 138.31Z'
      fill='white'
    />
    <path
      d='M95.6146 138.492L95.7707 142.381C95.7707 142.381 95.3935 143.825 96.9285 144.554L98.7107 145.425C98.7107 145.425 100.181 146.232 101.234 144.749C102.301 143.279 101.104 144.111 101.104 144.111L99.2441 142.238L98.2944 138.101L95.6146 138.492Z'
      fill='white'
    />
    <path
      d='M98.0732 138.14L98.3855 141.627C98.3855 141.627 98.2814 143.24 99.9725 143.916L101.937 144.762C101.937 144.762 103.888 145.451 104.07 143.604L101.833 141.991L100.597 137.607L98.0732 138.14Z'
      fill='white'
    />
    <path
      d='M100.519 137.828L100.909 140.196C100.909 140.196 101.013 141.861 102.431 142.681L103.784 143.63C103.784 143.63 104.643 144.138 105.28 143.526C105.709 143.11 105.358 142.629 105.02 142.199L103.823 140.69C103.823 140.69 102.834 139.324 103.316 137.477C103.29 137.477 100.519 136.384 100.519 137.828Z'
      fill='white'
    />
    <path
      d='M86.6126 25.9397L79.0155 26.6032C79.0155 26.6032 73.9941 30.3107 76.5958 34.8117L86.6126 25.9397Z'
      fill='#434748'
    />
    <path
      d='M79.3666 35.7353C81.8955 35.7353 83.9457 33.6852 83.9457 31.1563C83.9457 28.6273 81.8955 26.5771 79.3666 26.5771C76.8376 26.5771 74.7875 28.6273 74.7875 31.1563C74.7875 33.6852 76.8376 35.7353 79.3666 35.7353Z'
      fill='#434748'
    />
    <path
      d='M87.5622 46.3372C93.2092 46.3372 97.7871 41.7594 97.7871 36.1124C97.7871 30.4653 93.2092 25.8875 87.5622 25.8875C81.9151 25.8875 77.3373 30.4653 77.3373 36.1124C77.3373 41.7594 81.9151 46.3372 87.5622 46.3372Z'
      fill='#434748'
    />
    <path
      d='M86.3523 48.0936C91.9994 48.0936 96.5772 43.5158 96.5772 37.8687C96.5772 32.2217 91.9994 27.6438 86.3523 27.6438C80.7053 27.6438 76.1274 32.2217 76.1274 37.8687C76.1274 43.5158 80.7053 48.0936 86.3523 48.0936Z'
      fill='white'
    />
    <path
      d='M94.6129 42.7339L94.4828 41.6802L76.7519 34.3433L75.2428 37.9857C75.1908 38.1158 74.9957 38.6752 75.2428 39.2736L75.516 39.9501C75.516 39.9501 75.7762 40.6005 75.6591 41.2769L75.399 42.786C75.399 42.786 74.7745 45.6349 75.8933 47.7943L78.5471 52.8547C78.5471 52.8547 80.6545 57.7461 89.8517 51.697C89.8387 51.697 95.4065 48.0545 94.6129 42.7339Z'
      fill='white'
    />
    <path
      d='M93.0909 41.0298C93.5332 39.9631 94.704 39.4428 95.7057 39.8591C96.096 40.0152 96.3952 40.3014 96.6033 40.6396C96.9806 39.2607 98.4896 32.8993 94.5999 30.2195C94.5999 30.2195 92.0112 26.9804 87.3801 27.0454L79.7829 27.5527L77.2462 31.4814C77.2462 31.4814 85.3637 30.935 85.4287 30.935C85.9751 30.909 86.5475 30.9871 87.0939 31.2212C88.6159 31.8457 89.5135 33.3416 89.4485 34.9027C89.8647 35.0068 91.3738 35.6182 91.2957 38.6622L91.3477 42.5779L92.9088 42.6299L92.9348 41.7843C92.9478 41.5111 92.9999 41.264 93.0909 41.0298Z'
      fill='#434748'
    />
    <path d='M89.4486 34.5903C89.4486 34.5903 89.4486 34.8896 89.7608 35.0066H89.2014L89.4486 34.5903Z' fill='white' />
    <path
      d='M93.2471 40.7176C93.2471 40.7176 94.7561 38.3629 96.5643 40.2882C98.2295 42.0704 94.2618 48.8481 92.6227 46.0382L93.2471 40.7176Z'
      fill='white'
    />
    <path
      d='M79.0414 31.3513C79.0414 31.3513 78.326 31.3773 77.7666 32.314L77.4023 30.5317L79.0414 31.3513Z'
      fill='#434748'
    />
    <path
      d='M91.3348 42.3047C91.3348 42.3047 91.3088 42.5519 91.5689 42.5649L91.1396 42.76L91.3348 42.3047Z'
      fill='white'
    />
    <path
      d='M96.9284 50.3442L85.3506 62.9758L89.1231 67.0736L99.6863 53.7786L98.4634 51.0207C98.4634 51.0207 97.9041 49.3296 96.9284 50.3442Z'
      fill='#9D9B95'
    />
    <path
      d='M88.2386 66.1239C88.2386 66.1239 89.0452 67.1646 90.1119 65.8247L90.5412 66.8263L88.6029 67.6719C88.6029 67.6849 87.9394 66.8914 88.2386 66.1239Z'
      fill='#70706F'
    />
    <path
      d='M101.937 125.808C106.2 125.037 109.532 123.724 109.379 122.876C109.225 122.027 105.645 121.964 101.381 122.735C97.118 123.506 93.7862 124.818 93.9396 125.667C94.093 126.515 97.6735 126.578 101.937 125.808Z'
      fill='#70706F'
    />
    <path
      d='M99.1866 210.683C99.2509 209.773 96.1425 208.812 92.2439 208.536C88.3452 208.261 85.1327 208.776 85.0684 209.686C85.0041 210.596 88.1125 211.557 92.0111 211.832C95.9097 212.108 99.1223 211.593 99.1866 210.683Z'
      fill='#434748'
    />
    <path
      d='M136.782 201.445C139.777 198.933 141.614 196.193 140.884 195.323C140.155 194.453 137.136 195.783 134.141 198.294C131.146 200.806 129.309 203.546 130.038 204.416C130.768 205.286 133.787 203.956 136.782 201.445Z'
      fill='#434748'
    />
    <path
      d='M60.1136 219.9H22.8434C22.4661 219.9 22.1539 219.588 22.1539 219.211C22.1539 218.834 22.4661 218.521 22.8434 218.521H60.1136C60.4908 218.521 60.803 218.834 60.803 219.211C60.803 219.588 60.4908 219.9 60.1136 219.9Z'
      fill='#434748'
    />
    <path
      d='M169.791 219.9H148.339C147.962 219.9 147.65 219.588 147.65 219.211C147.65 218.834 147.962 218.521 148.339 218.521H169.791C170.168 218.521 170.48 218.834 170.48 219.211C170.48 219.588 170.168 219.9 169.791 219.9Z'
      fill='#434748'
    />
  </svg>
);
